import React, { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";

type DivProps = {
  className?: string;
  children: React.ReactNode;
};

const NewCommonServiceContent = ({ className, children }: DivProps) => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? "bg-white" : "bg-black"
      } py-5 px-5 sm:py-10 sm:px-10 transition-all duration-500`}
    >
      <div
        className={`${
          theme === "dark"
            ? " bg-primary sm:shadow-none"
            : "shadow-[0_0_20px_2px_#8D19DA] sm:shadow-[0_0_40px_10px_#8D19DA] bg-gradient"
        } p-1  sm:p-4 relative z-10 rounded-[16px] max-w-screen-2xl mx-auto transition-all duration-500`}
      >
        <div
          className={`${
            theme === "dark" ? "bg-primary" : "bg-black"
          } w-full mx-auto py-4 sm:py-16 px-4 sm:px-6 lg:px-8 relative rounded-[16px]  sm:shadow-none transition-all duration-500 `}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default NewCommonServiceContent;
